module.exports = __webpack_public_path__ + "static/9-bb1e4dc6333675d11ada2e857e7f95d7.woff";